import LZString from "lz-string";

import { FeatureGateOverrideValues } from "../feature-gates/types";

export const getExperimentOverrides = (
    parsedRequestCookies: Record<string, string>
): FeatureGateOverrideValues => {
    for (const cookieKey of Object.keys(parsedRequestCookies)) {
        if (
            cookieKey === "atlassian_exp_overrides" &&
            parsedRequestCookies["atlassian_exp_overrides"]
        ) {
            return decompressCookie(
                parsedRequestCookies["atlassian_exp_overrides"]
            );
        }
    }
    return {}; // return empty overrides if none are found
};

export const decompressCookie = (cookie: string) => {
    try {
        return JSON.parse(LZString.decompressFromBase64(cookie));
    } catch (e) {
        return {};
    }
};
